<template>
	
	<div class="wrap">
		<!-- 新建编辑专题对话框 -->
		<el-dialog
			:modal="true"
			:modal-append-to-body="false"
			:fullscreen="false"
			:visible.sync="centerDialogVisible"
			width="650px"
			center>
			<div class="dialog_title" slot="title">
				<div class="title_icon"><img src="../../../../assets/images/danghui_yellow.png" alt=""></div>
				<div class="title_text">新建专题</div>
			</div>
			<div class="addWrap">
						<el-form 
							label-position="left"
							label-width="95px"
							ref="formData" 
							:model="formData" 
							:rules="rules">
							<el-form-item class="form_item" label="专题名称：" prop="title">
								<el-input
								    type="textarea"
								    style="width:400px;height: 40px;"
									placeholder="请输入专题名称"
									v-model="formData.title">
								</el-input>
							</el-form-item>
							<el-form-item class="form_item" label="专题简介：" prop="introduct">
								<el-input
									placeholder="请输入专题简介"
									type="textarea"
									style="width:400px;height: 200px;"
									v-model="formData.introduct">
								</el-input>
							</el-form-item>
							<el-form-item class="form_item" label="上传封面" prop="sz_img">
								<el-upload
									:data="{token:$store.state.user.userinfo.token}"
									name="file"
									:action="$uploadImg"
									:show-file-list="false"
									:on-success="success"
									:before-upload="$limitImg">
									<!-- <img v-if="imageUrl" :src="imageUrl" class="fengmian"> -->
									<img v-if="formData.sz_img" :src="formData.sz_img" class="fengmian">
									<el-button  type="primary">{{formData.sz_img == null || formData.sz_img == ''?'上传封面':'重新上传'}}</el-button>
									<div class="tishi">支持格式：jpg、png，图片不得大于2M</div>
								</el-upload>
							</el-form-item>
							<!-- <div class="lists" v-if="formData.column_title.length>0">
								<div class="lists_item" v-for="(item,index) in formData.column_title">
									<span>{{$route.query.type=='add'?item:item.column_title}}</span>
									<span @click="delzhuanlan(index)">删除</span>
								</div>
							</div> -->
						
						</el-form>
					</div>
			<span slot="footer" class="dialog-footer">
				<el-button  @click="submit('formData')"  class="footer_button" type="primary" >保存</el-button>
				<el-button @click="submitCancel">取 消</el-button>
				
			</span>
	    </el-dialog>
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<!-- <el-breadcrumb-item>党建宣传</el-breadcrumb-item> -->
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<!-- 上方筛选框 -->
					<div class="selectbar">
						<el-date-picker
						class="select_year"
						v-model="getdata.year"
						type="year"
						size="small"
						placeholder="选择年份"
						value-format="yyyy"
						>
						</el-date-picker>
						<el-input
							placeholder="请输入名称查询"
							clearable
							prefix-icon="el-icon-search"
							style="width: 200px;"
							size="small"
							v-model="getdata.title"
							>
						</el-input>
						<div>
							<el-button type="primary" size="small" icon="el-icon-search" @click="searchList">查询</el-button>
							<el-button type="primary" size="small" icon="el-icon-check" @click="checked=false" v-if="checked">取消全选</el-button>
							<el-button v-else type="primary" size="small" icon="el-icon-check" @click="checked=true">全选</el-button>
							
							<el-button @click="delAll" type="primary" size="small" icon="el-icon-delete" >全部删除</el-button>
						</div>
					</div>
					<!-- 下方内容 -->
					<div class="selectdata" v-if="tableData.length>0">
						<!-- 新建专题按钮 -->
						<div class="selectdata_item" @click="centerDialogVisible = true,type='add'">
							<img src="../../../../assets/images/add_zjzt.png" alt="">
							<div class="add_content">
								点击创建资源专题
							</div>
						</div>
						<!-- 内容部分 -->
						<div class="selectdata_item" v-for="item in tableData" :key="item.id">
							<!-- 上方图片 -->
							<div class="selectdata_item_topimg" @click="goDetail(item)">
								<img :src="item.sz_img" alt="">
								<!-- 勾选框 -->
							   <div class="topChecked" v-if="checked">
								<el-checkbox
								  v-model="checked"
								  :border="false"
								  fill="#409EFF"
								  >
								</el-checkbox>
							    </div>
							</div>
							
							<div class="selectdata_item_bottom">
								<div class="selectdata_item_bottom_title" @click="goDetail(item)">
									{{item.title}}
								</div>
								<div class="selectdata_item_bottom_center">
									<div class="selectdata_item_bottom_center_left">创建时间：{{item.addtime}}</div>
									<div class="selectdata_item_bottom_center_right">
									资源数量：{{ item.count }}
									</div>
								</div>
								<div class="selectdata_item_bottom_botoom">
									<div class="selectdata_item_bottom_botoom_switch">
										<div class="switch">
											<el-switch
											@change="switchChange(item)"
											v-model="item.open"
											active-color="#1664FF"
											inactive-color="#C9CDD4">
											</el-switch>
										</div>
										<div v-if="value!=item.id" class="switch_title" >
											公开资源
										</div>
										<div v-if="value==item.id" class="switch_title">
											取消公开
										</div>
									</div>
									<div class="selectdata_item_bottom_botoom_right">
										<span  @click="editZjzt(item.id,'edit')">编辑</span>
										<span @click="goDetail(item)">详情</span>
										<span @click="delOne(item)">删除</span>
									</div>
								</div>
							</div>
                            <!-- 遮罩层 -->
							<div class="selectdata_item_mask" v-if="checked"></div>
						</div>
						<div class="selectdata_item">
						</div>
						<div class="selectdata_item">
						</div>
						<div class="selectdata_item">
						</div>
					</div>
					<!-- 下方内容无数据时展示 -->
					<div class="selectdata" v-if="tableData.length==0" >
						<!-- 新建专题按钮 -->
						<div class="selectdata_item" @click="centerDialogVisible = true,type='add'">
							<img src="../../../../assets/images/add_zjzt.png" alt="">
							<div class="add_content">
								点击创建资源专题
							</div>
						</div>
						<div class="none_bg">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/tree.vue'
	import { djxc,xxjy } from '@/axios'
	import Page from '@/components/page.vue'
	import DelData from '@/components/delToast.vue'
	import AddZt from '@/components/add_zt.vue'
	import { Message } from 'element-ui'
	
	let that;
	export default{
		data(){
			return{
				checked:false,
				// 删除选中的数据
				delDataList:[],
				value:'',
				getdata:{
					dwid:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					year:'',
					page:1,
					title:""
				},
				delList:[],
				tableData:[],
				totalPage:0,
				// 新建专题对话框
				centerDialogVisible:false,
				// centerDialogVisible2:false,
				// 新建专题
				formData:{
					id:"",
					dwid:this.$store.state.user.userinfo.dwid,
					flag:this.$store.state.user.userinfo.flag,
					status:1,
					title:"",
					introduct:"",
					sz_img:"",
					open:0,//默认不公开
					column_title:[]
				},
				rules:{
					title: [{ required: true, message: '请输入专题名称', trigger: 'blur' }],
					introduct: [{ required: true,message: '请输入专题简介',  trigger: 'blur', }],
					sz_img: [{ required: true,message: '请上传封面',  trigger: 'blur', }],
					
				},
				// imageUrl:"",
				type:''
			}
		},
		components:{tree,Page,DelData},
		created(){that = this},
		computed:{
			// tableHeader(){
			// 	let contralBar = {
			// 		prop: 'oper', label: '操作', fixed: 'right', width: '120',
			// 	};
			// 	let  tableHeader = [     // 表头
			// 		{prop: 'sz_img', label: '封面',width:"180"},
			// 		{prop: 'title', label: '标题',width:""},
			// 		{prop: 'pub_user', label: '发布人',width:"160"},
			// 		// 如果后端传过来的值不是我们所预期的，此处可以如下判断修改，isok是是否需要渲染为el-tag,效果为下图
			// 		{prop: 'pub_time', label: '发布时间',width:"110",formatData:(val) => {
			// 			return this.$changeTime(val)
			// 		}},
			// 		// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
			// 	];
			// 	if(this.$store.state.user.userinfo.flag==1){
			// 		contralBar = {
			// 			...contralBar,
			// 			oper: [
			// 				{name: '详情', style: {color:'#bb0000'}, clickFun: this.showDetail},
			// 				{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit},
			// 				{name: '删除', style: {color:'#bb0000'}, clickFun: this.del},
			// 			]
			// 		}
			// 	}else{
			// 		contralBar = {
			// 			...contralBar,
			// 			oper: [
			// 				{name: '详情', style: {color:'#bb0000'}, clickFun: this.showDetail},
			// 			]
			// 		}
			// 	}
			// 	tableHeader.push(contralBar)
			// 	return tableHeader
			// }
		},
		mounted() {
			that.dataList();
			
		},
		methods:{
			// 开关状态发生变化
			switchChange(data){
			//  公开资源接口
			 xxjy.openParty({
					id:data.id,
					open:data.open==true?1:0
				}).then(res => {
					if(res.code == 200){
						Message.success("设置成功")
						that.dataList();
					}else{
						Message.error(res.msg)
					}
				})
			},
			// 数据列表
			dataList(){
			xxjy.special(that.getdata).then(res => {
				if(res.data.pagedata.length>0){
					that.tableData = res.data.pagedata;
					// 遍历处理数据修改发布时间
					that.tableData.forEach((item,index,arr) => {
						// 转化时间
						arr[index].addtime=that.$changeTime(item.addtime)
						// 转化展示状态
						if (arr[index].open=='0') {
							arr[index].open=false
						}else{
							arr[index].open=true
						}
						
					});
				
					that.totalPage = res.data.count;
				}else{
					that.tableData = [];
					that.totalPage = 0;
				}
			})
			},
			// 详情
			goDetail(data){
				that.$router.push({
					path:"/zjzt_detail",
					query:{
						flag:data.dwid,
						id:data.id,
						introduct:data.introduct,
						type:'show'
					}
				})
			},
			// 编辑
			editZjzt(id,type){
				
				this.type=type
				this.centerDialogVisible=true
				xxjy.updateSpecial({
					id:id,
				}).then(res => {
					
					if(res.data.sz_img!=''&&res.data.sz_img!=null){
						that.formData.sz_img = res.data.sz_img;
						that.isUploaded = "重新上传"
					}
					for(var key in res.data){
						for(var i in that.formData){
							if(key == i){
								that.formData[i] = res.data[key]
							}
						}
					}
					
				})
			},
			//编辑提交
			submit(formData){
				var that = this;
				that.$refs[formData].validate((valid) => {
					if (valid) {
						if(that.type == 'edit'){
							// 编辑
							xxjy.updateSpecial1(that.formData).then(res => {
								if(res.code == 200){
									Message({
										type:"success",
										message:'编辑专题成功'
									})
								}else{
									Message({
										type:"error",
										message:res.msg
									})
								}
								this.centerDialogVisible = false
								// 清空新建专题中的数据列表
								that.formData.title=''
								that.formData.introduct=''
								that.formData.sz_img=''
								that.formData.imageUrl=''
								// 重新获取专题列表
								that.dataList()
							})
						}else{
						
							// 新增
							xxjy.addSpecial(that.formData).then(res => {
								if(res.code == 200){
									Message({
										type:"success",
										message:'添加专题成功'
									})
									
								}else{
									Message({
										type:"error",
										message:res.msg
									})
								}
								this.centerDialogVisible = false
								// 清空新建专题中的数据列表
								that.formData.title=''
								that.formData.introduct=''
								that.formData.sz_img=''
								that.formData.imageUrl=''
								// 重新获取专题列表
								that.dataList()

							})
						}
					} else {
						
						return false;
					}
				});
			},
			// 取消提交
			submitCancel(){
				
				let that=this
				// 关闭对话框
				that.centerDialogVisible = false
				// 清空对话框内容
				that.formData.title=''
				that.formData.introduct=''
				that.formData.sz_img=''
				that.formData.imageUrl=''
			},

			//删除选中
			delAll(){
				let that =this
				if(that.checked == false){
					Message.warning('请先选中需要删除的数据')
				}else{
					that.tableData.forEach((item)=>{
						that.delDataList.push(item.id)
					})
					
					that.delData();
				}
			},
			//	删除操作
			delData(){
				that.$refs.delDatas.showToast(res => {
					if(res){
						xxjy.delSpecial({
							id:that.delDataList,
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 删除
			delOne(data){
				that.delDataList = [];
				that.delDataList = [data.id];
				that.delData();
			},
			// 树形结构筛选
			treeSelect(data){
				that.getdata.id = data.id;
				that.getdata.flag = data.flag;
				that.getdata.page = 1;
				that.dataList();
			},
			// 分页筛选
			changedata(curret){
				that.getdata.page = curret;
				that.dataList();
			},
			// 上传封面图成功
			success(res, file) {
				var that = this;
				if(res.code == 200){
					that.imageUrl = URL.createObjectURL(file.raw);
					that.isUploaded = "重新上传"
					that.formData.sz_img = res.data.src
				}else{
					Message({
						type:"error",
						message:"上传失败，请检查文件或网络连接"
					})
				}
			},
			
			
			// 点击搜索
			searchList(){
				this.getdata.page = 1
				this.dataList();
			}
		
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
	}

	.selectdata{
		width:100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		
		.selectdata_item{
			position: relative;
			// margin-right: 14px;
			margin-bottom: 24px;
			width:19.5%;
			height: 305px;
			box-sizing: border-box;
			border-radius: 4px;
			border: 1px solid #DCDFE6;
			padding: 10px;
			.selectdata_item_topimg{
				position: relative;
				width: 100%;
				height: 170px;
				img{
					width: 100%;
					height: 100%;
				}
				.topChecked{
					position: absolute;
					top: -5px;
					right: 0;
					z-index: 999;
				}
			}
			.selectdata_item_bottom{
				box-sizing: border-box;
				width: 100%;
				height: 109px;
				padding-top: 8px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				// background-color: pink;
				.selectdata_item_bottom_title{
                    width: 100%;
					height: 22px;
					font-family: PingFangSC-Medium;
					font-size: 16px;
					font-weight: 800;
					letter-spacing: 0em;
					color: #000000;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.selectdata_item_bottom_title:hover{
					color: #EA0000;
				}
				.selectdata_item_bottom_center{
					width: 100%;
					height: 20px;
					line-height: 20px;
					display: flex;
					justify-content: space-between;
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					letter-spacing: 0em;
					color: #666666;
					flex-wrap: nowrap;
					overflow: hidden;
					
				}
				.selectdata_item_bottom_botoom{
					overflow: hidden;
					width: 100%;
					height: 24px;
					display: flex;
					justify-content: space-between;
					// background-color: pink;
					.selectdata_item_bottom_botoom_switch{
						width: 110px;
						height: 24px;
						display: flex;
						.switch{
							height: 100%;
							width: 40px;
							margin-right: 5px;
						}
						.switch_title{
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
					.selectdata_item_bottom_botoom_right{
					   white-space: nowrap;
                       span{
						font-family: PingFangSC-Regular;
						font-size: 16px;
						font-weight: normal;
						letter-spacing: 0em;
						color: #1C76FD;
						display: inline-block;
						box-sizing: border-box;
						padding: 0 0.7vw;
						cursor: pointer;
					   }
					   span:hover{
						font-weight: 800;
					   }
					   span:nth-child(3){
						border-left: 2px solid #DCDFE6;
						padding-right: 0;
					   }
					   span:nth-child(1){
						padding-left: 0;
						border-right: 2px solid #DCDFE6;
					   }
					   
					}
				}
			}
			.selectdata_item_mask{
                position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: rgba(255, 255, 255, 0.5);
				z-index: 999;
			}
		}
		
		.selectdata_item:hover{
			box-shadow: 0px 7px 29px 0px rgba(100, 100, 111, 0.2);
			position: relative;
			top:-10px;
		}
		.selectdata_item:nth-last-child(-n+3){
			border: none;
		}
		.selectdata_item:nth-last-child(-n+3):hover{
			box-shadow: none;
			position: relative;
			top:0px;
		}
		.selectdata_item:nth-child(1){
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			border-radius: 4px;
			border: 1px solid #DCDFE6;
			.add_content{
				font-family: PingFangSC-Regular;
				font-size: 12px;
				font-weight: normal;
				line-height: 20px;
				text-align: center;
				letter-spacing: 0px;
				color: #666666;
			}
		}
		
		
		
	}
	// dilog
	.dialog_title{
		    box-sizing: border-box;
			padding-bottom: 20px;
			display: flex;
			justify-content: center;
			border-bottom: 1px solid #DCDFE6;
			.title_icon{
				width: 24px;
				height: 24px;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.title_text{
				font-family: PingFangSC-Medium;
				font-size: 22px;
				font-weight: 800;
				text-align: center;
				letter-spacing: 0em;
				color: #EA0000;
				margin-left: 12px;
			}
	}
	.dialog-footer{
		.footer_button{
			margin-right: 70px;
		}
	}
	.datatable{
		.selectbar{
			display: flex !important;
			justify-content: right !important;;
		}

}
.select_year{
	width: 130px !important;
	margin-right: 16px;
}
.none_bg{
	width: 443px;
	height: 483px;
	background-image: url('../../../../assets/images/nocontentbackup.png');
	background-size: cover;
	margin-top: 149px;
	// margin-left: 237px;
	margin-right: 550px;
}
	
</style>

